<template>
  <footer class="footer" id="footer">
    <div class="container">
      <div class="footer__up">
        <div class="footer__up-items">
          <h2 class="footer__up-title">Мы ждем Вас</h2>
          <div class="footer__up-list -contacts">
            <ul>
              <li>
                <span class="footer__up-subname">Приходите: </span>
                <a href="https://go.2gis.com/lq2od" target="_blank">БЦ Кадам Инвест, Богенбай батыра, 150</a>
              </li>
              <li>
                <span class="footer__up-subname">Звоните:</span>
                <a href="tel:+77789920000">+ 7 778 992 00 00</a>
              </li>
              <li>
                <span class="footer__up-subname">Пишите:</span>
                <a href="mailto:Info@educenter.kz">Info@educenter.kz</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer__up-items">
          <h2 class="footer__up-title">Информация</h2>
          <div class="footer__up-list">
            <ul>
              <li><a href="/#about-video">О нас</a></li>
              <li><a href="/#price">Ценность и стоимость</a></li>
              <li><a href="/#reviews">Отзывы</a></li>
              <li><a href="/services">Услуги</a></li>
              <li><a href="/#works">Наши работы</a></li>
              <li><a href="/faq#faq-page">Вопросы</a></li>
              <li><a href="/#mobileApp">Мобильное приложение в подарок</a></li>
            </ul>
          </div>
        </div>
        <div class="footer__up-items">
          <h2 class="footer__up-title">Дополнительно</h2>
          <div class="footer__up-list">
            <ul>
              <li><a href="/docs/Реквизиты KZ206247.pdf" target="_blank">Реквизиты</a></li>
              <li><a href="/docs/Политика_обработки_персональных_данных.pdf" target="_blank">Политики конфиденциальности и обработки персональных данных</a></li>
              <li><a href="/docs/договор%20—%20Оферта.pdf" target="_blank">Правила оферты</a></li>
              <li><a href="/docs/Правила%20оплаты.pdf" target="_blank">Правила оплаты</a></li>
              <li><a href="/docs/Политика%20возврата.pdf" target="_blank">Правила возврата услуги возврата денежных средств</a></li>
              <li><span class="pay-logo -visa"></span><span class="pay-logo -mastercard"></span></li>
            </ul>
          </div>
        </div>

        <div class="footer__up-items">
          <h2 class="footer__up-title">Мы в соц сетях</h2>
          <div class="footer__up-list -social">
            <ul>
              <li><a href="https://www.facebook.com/profile.php?id=100084520423464" target="_blank"><img src="../assets/icons/ic-social-fb.svg" alt=""></a></li>
              <li><a href="https://www.instagram.com/educenter.kz/" target="_blank"><img src="../assets/icons/ic-social-ig.svg" alt=""></a></li>
              <li><a href="https://wa.me/+77789920000" target="_blank"><img src="../assets/icons/ic-social-wa.svg" alt=""></a></li>
              <li><a href="https://t.me/Educenterkz" target="_blank"><img src="../assets/icons/ic-social-tg.svg" alt=""></a></li>
              <li><a href="https://www.youtube.com/channel/UCjqdZ0Io9biQXed8wQVwo5Q" target="_blank"><img src="../assets/icons/ic-social-yt.svg" alt=""></a></li>
            </ul>
            <!-- <p class="footer__social-description">
              Узнавайте первыми о обновлении в вашем <a href="#"><span class="text-blue">в Telegram канале</span></a>
            </p> -->
            <div class="metrika-analytics">
              <!-- Yandex.Metrika informer --> <a href="https://metrika.yandex.kz/stat/?id=68727190&amp;from=informer" target="_blank" rel="nofollow"><img src="https://informer.yandex.ru/informer/68727190/3_1_FFFFFFFF_EFEFEFFF_0_visits" style="width:88px; height:31px; border:0;" alt="Яндекс.Метрика" title="Яндекс.Метрика: данные за сегодня (просмотры, визиты и уникальные посетители)" class="ym-advanced-informer" data-cid="68727190" data-lang="ru" /></a> <!-- /Yandex.Metrika informer --> 
            </div>
          </div>
        </div>
      </div>
      <div class="footer__down">
        <a href="/" class="footer__logo">
          <img src="../assets/logo.svg" alt="">
          Cоздайте свою онлайн школу <br>вместе с educenter
        </a>
        <div class="footer__app">
          <a href="https://play.google.com/store/apps/details?id=com.buginsoft.educenter" target="_blank" class="footer__app-android">
            <svg width="171" height="50" viewBox="0 0 171 50" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M164.667 50H6.33333C2.85158 50 0 47.1859 0 43.75V6.25C0 2.81407 2.85158 2.64247e-06 6.33333 2.64247e-06H164.667C168.148 2.64247e-06 171 2.81407 171 6.25V43.75C171 47.1859 168.148 50 164.667 50Z" fill="black"/>
              <path d="M164.667 1.00156C167.599 1.00156 169.985 3.35625 169.985 6.25V43.75C169.985 46.6438 167.599 48.9984 164.667 48.9984H6.33333C3.401 48.9984 1.01492 46.6438 1.01492 43.75V6.25C1.01492 3.35625 3.401 1.00156 6.33333 1.00156H164.667ZM164.667 2.64247e-06H6.33333C2.85158 2.64247e-06 0 2.81407 0 6.25V43.75C0 47.1859 2.85158 50 6.33333 50H164.667C168.148 50 171 47.1859 171 43.75V6.25C171 2.81407 168.148 2.64247e-06 164.667 2.64247e-06Z" fill="#A6A6A6"/>
              <path d="M53.1867 17.517V16.1018H58.2652V17.517H59.277V15.1435H58.3929V8.93649H53.6926L53.4323 13.2814C53.3782 14.2298 53.2014 14.8406 52.6955 15.1435H52.1798V17.517H53.1867ZM54.4539 13.336L54.67 9.89485H57.2927V15.1435H53.9774V15.0739C54.3065 14.6717 54.4047 14.1305 54.4539 13.336Z" fill="white"/>
              <path d="M63.2965 16.2756C65.3446 16.2756 66.602 14.8157 66.602 12.5216V12.5117C66.602 10.2126 65.3348 8.7627 63.2965 8.7627C61.2631 8.7627 59.9861 10.2077 59.9861 12.5117V12.5216C59.9861 14.8207 61.2337 16.2756 63.2965 16.2756ZM63.2965 15.2924C61.9311 15.2924 61.1109 14.2 61.1109 12.5216V12.5117C61.1109 10.8184 61.9557 9.74588 63.2965 9.74588C64.6374 9.74588 65.4772 10.8184 65.4772 12.5117V12.5216C65.4772 14.2 64.6423 15.2924 63.2965 15.2924Z" fill="white"/>
              <path d="M70.8327 16.2756C72.4142 16.2756 73.5684 15.3619 73.7747 13.9865V13.9567H72.6844L72.6745 13.9765C72.4732 14.7859 71.7708 15.2924 70.8327 15.2924C69.5557 15.2924 68.76 14.2248 68.76 12.5266V12.5167C68.76 10.8135 69.5557 9.74588 70.8278 9.74588C71.761 9.74588 72.4732 10.3169 72.6794 11.1958V11.2107H73.7698L73.7747 11.1859C73.5881 9.76078 72.3897 8.7627 70.8278 8.7627C68.8583 8.7627 67.6353 10.2027 67.6353 12.5167V12.5266C67.6353 14.8356 68.8632 16.2756 70.8327 16.2756Z" fill="white"/>
              <path d="M76.5271 16.1018H77.6273V9.89485H79.8522V8.93649H74.2972V9.89485H76.5271V16.1018Z" fill="white"/>
              <path d="M81.7008 16.1564C82.9483 16.1564 83.4837 15.4017 84.0534 14.051L86.2243 8.93649H85.075L83.3609 13.341H83.2774L81.5142 8.93649H80.3403L82.7372 14.5079C82.4719 14.9846 82.133 15.1782 81.637 15.1782C81.4258 15.1782 81.2981 15.1534 81.2293 15.1385V16.0919C81.2784 16.1117 81.4602 16.1564 81.7008 16.1564Z" fill="white"/>
              <path d="M93.0533 16.1018V8.93649H87.2871V16.1018H88.3873V9.89485H91.9531V16.1018H93.0533Z" fill="white"/>
              <path d="M94.6612 16.1018H95.7614V12.9288H99.4009V16.1018H100.496V8.93649H99.4009V11.9655H95.7614V8.93649H94.6612V16.1018Z" fill="white"/>
              <path d="M105.125 16.2756C107.173 16.2756 108.43 14.8157 108.43 12.5216V12.5117C108.43 10.2126 107.163 8.7627 105.125 8.7627C103.091 8.7627 101.814 10.2077 101.814 12.5117V12.5216C101.814 14.8207 103.062 16.2756 105.125 16.2756ZM105.125 15.2924C103.759 15.2924 102.939 14.2 102.939 12.5216V12.5117C102.939 10.8184 103.784 9.74588 105.125 9.74588C106.466 9.74588 107.305 10.8184 107.305 12.5117V12.5216C107.305 14.2 106.47 15.2924 105.125 15.2924Z" fill="white"/>
              <path d="M112.236 16.1018H115.148C116.661 16.1018 117.569 15.3371 117.569 14.0808V14.0709C117.569 13.1374 116.931 12.4521 115.973 12.3478V12.2634C116.671 12.1443 117.216 11.4739 117.216 10.7291V10.7191C117.216 9.62174 116.415 8.93649 115.084 8.93649H112.236V16.1018ZM114.829 9.84519C115.644 9.84519 116.121 10.2375 116.121 10.9128V10.9227C116.121 11.6179 115.615 11.9854 114.642 11.9854H113.336V9.84519H114.829ZM114.863 12.8345C115.9 12.8345 116.445 13.2317 116.445 14.0014V14.0113C116.445 14.781 115.919 15.1931 114.927 15.1931H113.336V12.8345H114.863Z" fill="white"/>
              <path d="M86.3043 27.1904C83.3292 27.1904 80.8988 29.4248 80.8988 32.5076C80.8988 35.5654 83.3292 37.8232 86.3043 37.8232C89.2857 37.8232 91.7162 35.5654 91.7162 32.5076C91.7162 29.4248 89.2857 27.1904 86.3043 27.1904ZM86.3043 35.7295C84.6719 35.7295 83.2675 34.3998 83.2675 32.5076C83.2675 30.5904 84.6719 29.2842 86.3043 29.2842C87.9367 29.2842 89.3475 30.5904 89.3475 32.5076C89.3475 34.3998 87.9367 35.7295 86.3043 35.7295ZM74.5101 27.1904C71.5287 27.1904 69.1046 29.4248 69.1046 32.5076C69.1046 35.5654 71.5287 37.8232 74.5101 37.8232C77.4899 37.8232 79.9156 35.5654 79.9156 32.5076C79.9156 29.4248 77.4899 27.1904 74.5101 27.1904ZM74.5101 35.7295C72.8761 35.7295 71.4669 34.3998 71.4669 32.5076C71.4669 30.5904 72.8761 29.2842 74.5101 29.2842C76.1425 29.2842 77.5469 30.5904 77.5469 32.5076C77.5469 34.3998 76.1425 35.7295 74.5101 35.7295ZM60.4754 28.8201V31.0795H65.9427C65.7828 32.342 65.3553 33.2701 64.6998 33.917C63.9018 34.6982 62.6588 35.5654 60.4754 35.5654C57.1108 35.5654 54.4762 32.8857 54.4762 29.5654C54.4762 26.2451 57.1108 23.5654 60.4754 23.5654C62.2947 23.5654 63.6183 24.267 64.5953 25.1764L66.2087 23.5842C64.8423 22.2967 63.0246 21.3076 60.4754 21.3076C55.8616 21.3076 51.984 25.0123 51.984 29.5654C51.984 34.1186 55.8616 37.8232 60.4754 37.8232C62.9692 37.8232 64.8423 37.017 66.3148 35.5045C67.8237 34.0154 68.2939 31.9217 68.2939 30.2311C68.2939 29.7061 68.2496 29.2232 68.1704 28.8201H60.4754ZM117.865 30.5717C117.42 29.3826 116.047 27.1904 113.251 27.1904C110.48 27.1904 108.173 29.3451 108.173 32.5076C108.173 35.4857 110.456 37.8232 113.517 37.8232C115.992 37.8232 117.42 36.3342 118.007 35.467L116.171 34.2592C115.558 35.1436 114.724 35.7295 113.517 35.7295C112.318 35.7295 111.459 35.1873 110.908 34.1186L118.113 31.1764L117.865 30.5717ZM110.518 32.342C110.456 30.292 112.132 29.242 113.332 29.242C114.272 29.242 115.07 29.7061 115.336 30.3701L110.518 32.342ZM104.661 37.4998H107.03V21.8748H104.661V37.4998ZM100.782 28.3748H100.703C100.171 27.7529 99.1562 27.1904 97.8706 27.1904C95.1726 27.1904 92.7057 29.5279 92.7057 32.5248C92.7057 35.5045 95.1726 37.8232 97.8706 37.8232C99.1562 37.8232 100.171 37.2561 100.703 36.6154H100.782V37.3779C100.782 39.4107 99.6819 40.5029 97.907 40.5029C96.4598 40.5029 95.5621 39.4717 95.1916 38.6045L93.1317 39.4529C93.7254 40.8623 95.2977 42.5967 97.907 42.5967C100.684 42.5967 103.027 40.9842 103.027 37.0607V27.5139H100.782V28.3748ZM98.0732 35.7295C96.4408 35.7295 95.0744 34.3811 95.0744 32.5248C95.0744 30.6514 96.4408 29.2842 98.0732 29.2842C99.6819 29.2842 100.95 30.6514 100.95 32.5248C100.95 34.3811 99.6819 35.7295 98.0732 35.7295ZM128.955 21.8748H123.289V37.4998H125.652V31.5795H128.955C131.578 31.5795 134.151 29.7061 134.151 26.7264C134.151 23.7482 131.572 21.8748 128.955 21.8748ZM129.016 29.4061H125.652V24.0482H129.016C130.78 24.0482 131.787 25.4936 131.787 26.7264C131.787 27.9357 130.78 29.4061 129.016 29.4061ZM143.619 27.1607C141.913 27.1607 140.138 27.9045 139.408 29.5529L141.504 30.4201C141.955 29.5529 142.785 29.2717 143.662 29.2717C144.888 29.2717 146.131 29.9982 146.15 31.2811V31.4451C145.722 31.2014 144.807 30.8404 143.681 30.8404C141.423 30.8404 139.123 32.067 139.123 34.3561C139.123 36.4498 140.972 37.7982 143.051 37.7982C144.641 37.7982 145.518 37.0904 146.069 36.267H146.15V37.4748H148.431V31.4811C148.431 28.7107 146.335 27.1607 143.619 27.1607ZM143.334 35.7232C142.562 35.7232 141.485 35.3451 141.485 34.3998C141.485 33.1904 142.828 32.7264 143.99 32.7264C145.03 32.7264 145.518 32.9529 146.15 33.2514C145.964 34.6982 144.702 35.7232 143.334 35.7232ZM156.744 27.5029L154.028 34.2764H153.947L151.14 27.5029H148.593L152.811 36.9686L150.404 42.2357H152.872L159.372 27.5029H156.744ZM135.449 37.4998H137.818V21.8748H135.449V37.4998Z" fill="white"/>
              <path d="M13.2176 9.42323C12.8455 9.80761 12.6302 10.406 12.6302 11.181V38.8248C12.6302 39.5998 12.8455 40.1982 13.2176 40.5826L13.3094 40.667L29.0066 25.1826V24.817L13.3094 9.33261L13.2176 9.42323Z" fill="url(#paint0_linear_437_2259)"/>
              <path d="M34.2332 30.3467L29.0067 25.1826V24.817L34.2396 19.6529L34.3567 19.7201L40.5539 23.1998C42.3225 24.1873 42.3225 25.8123 40.5539 26.8061L34.3567 30.2795L34.2332 30.3467Z" fill="url(#paint1_linear_437_2259)"/>
              <path d="M34.3567 30.2796L29.0066 24.9999L13.2177 40.5827C13.8051 41.1921 14.763 41.2655 15.8523 40.6562L34.3567 30.2796Z" fill="url(#paint2_linear_437_2259)"/>
              <path d="M34.3567 19.7203L15.8523 9.34375C14.763 8.74063 13.8051 8.81406 13.2177 9.42344L29.0066 25L34.3567 19.7203Z" fill="url(#paint3_linear_437_2259)"/>
              <defs>
                <linearGradient id="paint0_linear_437_2259" x1="27.6129" y1="39.1127" x2="6.63672" y2="17.8568" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#00A0FF"/>
                  <stop offset="0.0066" stop-color="#00A1FF"/>
                  <stop offset="0.2601" stop-color="#00BEFF"/>
                  <stop offset="0.5122" stop-color="#00D2FF"/>
                  <stop offset="0.7604" stop-color="#00DFFF"/>
                  <stop offset="1" stop-color="#00E3FF"/>
                </linearGradient>
                <linearGradient id="paint1_linear_437_2259" x1="42.8569" y1="24.9981" x2="12.2075" y2="24.9981" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#FFE000"/>
                  <stop offset="0.4087" stop-color="#FFBD00"/>
                  <stop offset="0.7754" stop-color="#FFA500"/>
                  <stop offset="1" stop-color="#FF9C00"/>
                </linearGradient>
                <linearGradient id="paint2_linear_437_2259" x1="31.4475" y1="22.1298" x2="3.00214" y2="-6.69487" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#FF3A44"/>
                  <stop offset="1" stop-color="#C31162"/>
                </linearGradient>
                <linearGradient id="paint3_linear_437_2259" x1="9.24323" y1="49.7798" x2="21.9454" y2="36.9084" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#32A071"/>
                  <stop offset="0.0685" stop-color="#2DA771"/>
                  <stop offset="0.4762" stop-color="#15CF74"/>
                  <stop offset="0.8009" stop-color="#06E775"/>
                  <stop offset="1" stop-color="#00F076"/>
                </linearGradient>
              </defs>
            </svg>
          </a>
          <a href="https://apps.apple.com/kz/app/educenter/id1543607494" target="_blank" class="footer__app-ios">
            <svg width="171" height="50" viewBox="0 0 171 50" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M170.05 44.2337C170.05 46.8982 167.873 49.0566 165.18 49.0566H5.82576C3.13448 49.0566 0.949951 46.8982 0.949951 44.2337V5.77256C0.949951 3.10926 3.13448 0.943359 5.82576 0.943359H165.179C167.873 0.943359 170.049 3.10926 170.049 5.77256L170.05 44.2337Z" fill="black"/>
              <path d="M164.667 1.00156C167.599 1.00156 169.985 3.35625 169.985 6.25V43.75C169.985 46.6438 167.599 48.9984 164.667 48.9984H6.33333C3.401 48.9984 1.01492 46.6438 1.01492 43.75V6.25C1.01492 3.35625 3.401 1.00156 6.33333 1.00156H164.667ZM164.667 2.64247e-06H6.33333C2.85158 2.64247e-06 0 2.81407 0 6.25V43.75C0 47.1859 2.85158 50 6.33333 50H164.667C168.148 50 171 47.1859 171 43.75V6.25C171 2.81407 168.148 2.64247e-06 164.667 2.64247e-06Z" fill="#A6A6A6"/>
              <path d="M38.1622 24.7302C38.1254 20.7015 41.5049 18.7415 41.6594 18.6502C39.7455 15.8965 36.779 15.5202 35.7365 15.4902C33.245 15.2315 30.8282 16.9615 29.559 16.9615C28.2644 16.9615 26.31 15.5152 24.2035 15.5577C21.4928 15.599 18.957 17.1477 17.5662 19.5527C14.6959 24.4565 16.8366 31.6627 19.5865 35.6265C20.9621 37.5677 22.5695 39.7352 24.6734 39.659C26.7318 39.5752 27.5006 38.364 29.9846 38.364C32.4457 38.364 33.1677 39.659 35.3134 39.6102C37.5225 39.5752 38.9133 37.6602 40.2408 35.7015C41.8304 33.4765 42.4688 31.2852 42.4942 31.1727C42.4422 31.1552 38.204 29.559 38.1622 24.7302Z" fill="white"/>
              <path d="M34.1088 12.8827C35.2159 11.5165 35.9734 9.65773 35.7631 7.77148C34.1608 7.84148 32.1569 8.86523 31.003 10.2015C29.982 11.379 29.07 13.309 29.3056 15.124C31.1056 15.2565 32.9536 14.2277 34.1088 12.8827Z" fill="white"/>
              <path d="M67.9502 39.3801H65.0736L63.4979 34.4939H58.0208L56.5198 39.3801H53.7192L59.1456 22.7451H62.4972L67.9502 39.3801ZM63.0229 32.4439L61.5979 28.1001C61.4472 27.6564 61.1647 26.6114 60.748 24.9664H60.6973C60.5314 25.6739 60.2641 26.7189 59.8968 28.1001L58.4971 32.4439H63.0229Z" fill="white"/>
              <path d="M81.9051 33.2349C81.9051 35.2749 81.3465 36.8874 80.2293 38.0712C79.2286 39.1249 77.986 39.6512 76.5028 39.6512C74.9017 39.6512 73.7516 39.0837 73.0511 37.9487H73.0004V44.2674H70.2999V31.3337C70.2999 30.0512 70.2657 28.7349 70.1998 27.3849H72.5748L72.7256 29.2862H72.7762C73.6768 27.8537 75.0436 27.1387 76.8777 27.1387C78.3116 27.1387 79.5086 27.6974 80.4662 28.8162C81.4263 29.9362 81.9051 31.4087 81.9051 33.2349ZM79.1539 33.3324C79.1539 32.1649 78.8879 31.2024 78.3534 30.4449C77.7694 29.6549 76.9854 29.2599 76.0024 29.2599C75.3362 29.2599 74.7307 29.4799 74.1898 29.9137C73.6477 30.3512 73.293 30.9224 73.1271 31.6299C73.0435 31.9599 73.0017 32.2299 73.0017 32.4424V34.4424C73.0017 35.3149 73.2728 36.0512 73.8149 36.6524C74.357 37.2537 75.0613 37.5537 75.9277 37.5537C76.9448 37.5537 77.7365 37.1662 78.3027 36.3937C78.8702 35.6199 79.1539 34.5999 79.1539 33.3324Z" fill="white"/>
              <path d="M95.8853 33.2349C95.8853 35.2749 95.3267 36.8874 94.2082 38.0712C93.2088 39.1249 91.9662 39.6512 90.4829 39.6512C88.8819 39.6512 87.7317 39.0837 87.0325 37.9487H86.9819V44.2674H84.2813V31.3337C84.2813 30.0512 84.2471 28.7349 84.1813 27.3849H86.5563L86.707 29.2862H86.7577C87.657 27.8537 89.0237 27.1387 90.8591 27.1387C92.2917 27.1387 93.4887 27.6974 94.4489 28.8162C95.4052 29.9362 95.8853 31.4087 95.8853 33.2349ZM93.1341 33.3324C93.1341 32.1649 92.8668 31.2024 92.3323 30.4449C91.7483 29.6549 90.9668 29.2599 89.9826 29.2599C89.3151 29.2599 88.7109 29.4799 88.1687 29.9137C87.6266 30.3512 87.2732 30.9224 87.1073 31.6299C87.0249 31.9599 86.9819 32.2299 86.9819 32.4424V34.4424C86.9819 35.3149 87.2529 36.0512 87.7925 36.6524C88.3347 37.2524 89.0389 37.5537 89.9079 37.5537C90.925 37.5537 91.7167 37.1662 92.2829 36.3937C92.8503 35.6199 93.1341 34.5999 93.1341 33.3324Z" fill="white"/>
              <path d="M111.516 34.7147C111.516 36.1297 111.018 37.281 110.019 38.1697C108.92 39.141 107.392 39.626 105.427 39.626C103.613 39.626 102.159 39.281 101.058 38.5897L101.684 36.3685C102.87 37.076 104.17 37.431 105.588 37.431C106.605 37.431 107.397 37.2035 107.965 36.751C108.532 36.2985 108.814 35.691 108.814 34.9335C108.814 34.2585 108.581 33.6897 108.114 33.2285C107.649 32.7672 106.872 32.3385 105.788 31.9422C102.837 30.856 101.362 29.2647 101.362 27.1722C101.362 25.8047 101.879 24.6835 102.914 23.811C103.945 22.9372 105.321 22.501 107.041 22.501C108.575 22.501 109.849 22.7647 110.866 23.291L110.191 25.4635C109.241 24.9535 108.167 24.6985 106.965 24.6985C106.015 24.6985 105.272 24.9297 104.74 25.3897C104.291 25.801 104.065 26.3022 104.065 26.896C104.065 27.5535 104.322 28.0972 104.839 28.5247C105.289 28.9197 106.106 29.3472 107.292 29.8085C108.742 30.3847 109.807 31.0585 110.492 31.831C111.175 32.601 111.516 33.5647 111.516 34.7147Z" fill="white"/>
              <path d="M120.445 29.3843H117.468V35.208C117.468 36.6893 117.992 37.4293 119.044 37.4293C119.526 37.4293 119.927 37.388 120.243 37.3055L120.318 39.3293C119.786 39.5255 119.086 39.6243 118.218 39.6243C117.151 39.6243 116.318 39.303 115.716 38.6618C115.117 38.0193 114.816 36.9418 114.816 35.428V29.3818H113.042V27.3818H114.816V25.1855L117.468 24.3955V27.3818H120.445V29.3843Z" fill="white"/>
              <path d="M133.875 33.2834C133.875 35.1271 133.341 36.6409 132.274 37.8246C131.156 39.0434 129.671 39.6509 127.821 39.6509C126.037 39.6509 124.617 39.0671 123.558 37.8996C122.499 36.7321 121.97 35.2584 121.97 33.4821C121.97 31.6234 122.515 30.1009 123.608 28.9171C124.698 27.7321 126.17 27.1396 128.021 27.1396C129.804 27.1396 131.239 27.7234 132.322 28.8921C133.358 30.0259 133.875 31.4896 133.875 33.2834ZM131.073 33.3696C131.073 32.2634 130.834 31.3146 130.349 30.5234C129.783 29.5659 128.973 29.0884 127.924 29.0884C126.839 29.0884 126.014 29.5671 125.448 30.5234C124.963 31.3159 124.724 32.2796 124.724 33.4196C124.724 34.5259 124.963 35.4746 125.448 36.2646C126.032 37.2221 126.848 37.6996 127.9 37.6996C128.931 37.6996 129.741 37.2121 130.325 36.2396C130.823 35.4334 131.073 34.4746 131.073 33.3696Z" fill="white"/>
              <path d="M142.653 29.7287C142.386 29.6799 142.101 29.6549 141.802 29.6549C140.852 29.6549 140.117 30.0087 139.601 30.7174C139.151 31.3424 138.925 32.1324 138.925 33.0862V39.3799H136.226L136.251 31.1624C136.251 29.7799 136.217 28.5212 136.15 27.3862H138.502L138.601 29.6812H138.676C138.961 28.8924 139.411 28.2574 140.026 27.7812C140.628 27.3524 141.278 27.1387 141.978 27.1387C142.228 27.1387 142.453 27.1562 142.653 27.1874V29.7287Z" fill="white"/>
              <path d="M154.731 32.815C154.731 33.2925 154.699 33.695 154.632 34.0237H146.53C146.562 35.2087 146.954 36.115 147.706 36.74C148.389 37.2987 149.272 37.5787 150.356 37.5787C151.555 37.5787 152.65 37.39 153.634 37.0112L154.057 38.8612C152.907 39.3562 151.549 39.6025 149.982 39.6025C148.097 39.6025 146.618 39.055 145.541 37.9612C144.467 36.8675 143.929 35.3987 143.929 33.5562C143.929 31.7475 144.429 30.2412 145.431 29.04C146.48 27.7575 147.897 27.1162 149.681 27.1162C151.432 27.1162 152.759 27.7575 153.659 29.04C154.372 30.0587 154.731 31.3187 154.731 32.815ZM152.156 32.1237C152.173 31.3337 151.997 30.6512 151.631 30.075C151.164 29.3337 150.446 28.9637 149.479 28.9637C148.596 28.9637 147.878 29.325 147.33 30.05C146.88 30.6262 146.613 31.3175 146.53 32.1225H152.156V32.1237Z" fill="white"/>
              <path d="M54.9053 12.9189H55.8827C56.8748 12.9189 57.4445 13.3707 57.4445 14.0957V14.1057C57.4445 14.8207 56.8355 15.2974 55.9171 15.2974C55.0182 15.2974 54.4043 14.8902 54.3306 14.2099L54.3257 14.1752H53.255V14.2248C53.3385 15.4613 54.3945 16.2756 55.9171 16.2756C57.4102 16.2756 58.5644 15.3719 58.5644 14.1603V14.1503C58.5644 13.1473 57.9062 12.5067 56.9878 12.4124V12.328C57.7736 12.1443 58.3188 11.4838 58.3188 10.6993V10.6893C58.3188 9.55719 57.3365 8.7627 55.9416 8.7627C54.4976 8.7627 53.5448 9.52739 53.4466 10.7589L53.4367 10.8383H54.4927L54.4976 10.8035C54.5664 10.1332 55.0968 9.74091 55.9072 9.74091C56.7373 9.74091 57.2284 10.1531 57.2284 10.8035V10.8135C57.2284 11.5037 56.6931 11.9804 55.8532 11.9804H54.9053V12.9189Z" fill="white"/>
              <path d="M61.1154 16.1912C61.8226 16.1912 62.3825 15.8833 62.6969 15.3371H62.7804V16.1018H63.8364V12.4124C63.8364 11.2802 63.08 10.6049 61.7391 10.6049C60.526 10.6049 59.6861 11.1958 59.5584 12.0797L59.5535 12.1145H60.58L60.5849 12.0946C60.7126 11.7122 61.1006 11.4938 61.69 11.4938C62.412 11.4938 62.7804 11.8215 62.7804 12.4124V12.8891L61.3364 12.9735C60.0643 13.0529 59.3472 13.6141 59.3472 14.5774V14.5873C59.3472 15.5655 60.0987 16.1912 61.1154 16.1912ZM60.4081 14.5426V14.5327C60.4081 14.0461 60.7421 13.7779 61.4788 13.7332L62.7804 13.6488V14.1106C62.7804 14.8058 62.1959 15.3321 61.4002 15.3321C60.8256 15.3321 60.4081 15.0392 60.4081 14.5426Z" fill="white"/>
              <path d="M68.6859 11.5583V10.7092H65.1644V16.1018H66.2302V11.5583H68.6859Z" fill="white"/>
              <path d="M69.6751 17.8993H70.7409V15.2477H70.8194C71.1043 15.8287 71.7281 16.1912 72.4599 16.1912C73.8155 16.1912 74.6701 15.1186 74.6701 13.4105V13.4005C74.6701 11.7023 73.8057 10.6149 72.4599 10.6149C71.7133 10.6149 71.1289 10.9674 70.8194 11.5583H70.7409V10.7092H69.6751V17.8993ZM72.1603 15.2726C71.2713 15.2726 70.7212 14.5625 70.7212 13.4105V13.4005C70.7212 12.2485 71.2713 11.5385 72.1603 11.5385C73.0493 11.5385 73.5846 12.2386 73.5846 13.4005V13.4105C73.5846 14.5674 73.0493 15.2726 72.1603 15.2726Z" fill="white"/>
              <path d="M76.0963 17.9987C77.1769 17.9987 77.7171 17.5964 78.169 16.3104L80.1533 10.7092H79.0334L77.7024 15.0193H77.6091L76.2731 10.7092H75.1238L77.059 16.1068L76.9804 16.3848C76.8232 16.9311 76.5236 17.1446 76.0276 17.1446C75.9048 17.1446 75.7722 17.1396 75.669 17.1247V17.9738C75.8065 17.9887 75.9637 17.9987 76.0963 17.9987Z" fill="white"/>
              <path d="M82.7779 16.2061C84.0942 16.2061 84.9586 15.5159 84.9586 14.5178V14.5079C84.9586 13.9021 84.5952 13.475 83.8683 13.3211V13.2367C84.4233 13.1076 84.7769 12.6458 84.7769 12.0896V12.0797C84.7769 11.1859 84.0402 10.6 82.8074 10.6C81.5942 10.6 80.828 11.2008 80.7052 12.1145L80.7003 12.1492H81.7219L81.7268 12.1244C81.8054 11.7172 82.2131 11.454 82.7828 11.454C83.4213 11.454 83.7406 11.7669 83.7406 12.1889V12.1989C83.7406 12.6954 83.4066 12.9586 82.7632 12.9586H81.9724V13.7432H82.7681C83.5097 13.7432 83.9076 13.9964 83.9076 14.5178V14.5277C83.9076 15.0144 83.4852 15.357 82.7681 15.357C82.164 15.357 81.7268 15.0988 81.6188 14.6717L81.609 14.637H80.5579L80.5628 14.6767C80.6758 15.6499 81.5942 16.2061 82.7779 16.2061Z" fill="white"/>
              <path d="M86.0656 16.1018H87.1216L89.5332 12.3031H89.6265V16.1018H90.6825V10.7092H89.6265L87.2149 14.493H87.1216V10.7092H86.0656V16.1018Z" fill="white"/>
              <path d="M96.033 10.7092H91.6077V11.5583H93.2875V16.1018H94.3533V11.5583H96.033V10.7092Z" fill="white"/>
              <path d="M99.0211 16.2061C100.387 16.2061 101.123 15.4116 101.3 14.7015L101.31 14.6568L100.283 14.6618L100.264 14.7015C100.136 14.9796 99.7284 15.3222 99.0457 15.3222C98.1665 15.3222 97.6066 14.7214 97.587 13.6885H101.369V13.3112C101.369 11.6924 100.455 10.6049 98.9671 10.6049C97.4789 10.6049 96.5163 11.7321 96.5163 13.4154V13.4204C96.5163 15.1286 97.4593 16.2061 99.0211 16.2061ZM98.972 11.4888C99.694 11.4888 100.229 11.9556 100.313 12.9189H97.6017C97.695 11.9903 98.2451 11.4888 98.972 11.4888Z" fill="white"/>
              <path d="M104.943 16.1018H107.379C108.553 16.1018 109.256 15.4861 109.256 14.5625V14.5526C109.256 13.912 108.804 13.4254 108.111 13.341V13.2565C108.637 13.1572 109.015 12.6557 109.015 12.1045V12.0946C109.015 11.2554 108.401 10.7092 107.355 10.7092H104.943V16.1018ZM105.999 12.9685V11.4987H107.139C107.704 11.4987 107.964 11.7917 107.964 12.2237V12.2336C107.964 12.7103 107.664 12.9685 107.026 12.9685H105.999ZM105.999 15.3073V13.7432H107.104C107.817 13.7432 108.165 13.9914 108.165 14.5128V14.5228C108.165 15.0193 107.856 15.3073 107.242 15.3073H105.999Z" fill="white"/>
            </svg>
          </a>
        </div>
        <div class="footer__copyright">
          <a href="https://buginholding.com/" target="_blank">by Bugin Holding, 2013-{{ dateYear }}</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      dateYear: '' 
    }
  },
  methods: {

  },
  mounted() {
    this.dateYear = new Date().getFullYear()
  }
}
</script>

<style>
  .footer {
    background: #F8FAFF;
    padding: 0;
    display: flex;
  }

  .footer__up {
    display: flex;
    align-items: flex-start;
    gap: 32px;
    padding: 26px 0;
    border-bottom: 1px solid #EEE;
    position: relative;
  }

  .footer__up-items {
    width: 100%;
  }

  .footer__up-title{
    font-family: "SF Pro Display";
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 135%;
    color: var(--text1);
    margin-bottom: 20px;
  }

  .footer__up-list.-contacts ul,
  .footer__up-list.-social ul,
  .footer__up-list ul{
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .footer__up-list.-contacts ul li span {
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 120%;
    color: #9C9C9C;
    margin-bottom: 14px;
  }

  .footer__up-list.-contacts ul li a {
    font-family: "SF Pro Display";
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 135%;
    color: var(--main-color);
  }

  .footer__up-list.-contacts ul li a:hover {
    color: var(--main-hover);
  }

  .footer__up-list.-contacts ul li {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
  }

  .footer__up-list.-contacts ul li:nth-last-child(1){
    margin-bottom: 0;
  }

  .footer__up-list ul li {
    margin-bottom: 10px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    gap: 10px;
  }

  .footer__up-list ul li a {
    color: var(--text1);
  }

  .footer__up-list ul li a:hover {
    color: var(--text1-hover);
  }

  .footer__up-list.-social ul {
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .footer__up-list .pay-logo {
    position: relative;
    width: 58px;
    height: 33px;
    display: flex;
  }
  .footer__up-list .pay-logo::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  .footer__up-list .pay-logo.-visa::after {
    background-image: url("../assets/icons/visa-logo.png");
  }
  .footer__up-list .pay-logo.-mastercard::after {
    background-image: url("../assets/icons/mastercard-logo.png");
  }
  .footer__social-description {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 135%;
    color: #65737E;
  }

  .metrika-analytics {
    position: relative;
    margin-top: 1rem;
  }

  .footer__down {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 26px 0 40px 0;
  }

  .footer__app {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .footer__logo {
    display: flex;
    align-items: center;
    font-family: "SF Pro Display";
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 120%;
    letter-spacing: 0.01em;
    color: var(--main-color);
    column-gap: 10px;
    user-select: none;
  }

  .footer__copyright a {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    color: #aaaeb3;
    user-select: none;
  }



  @media (max-width: 1400px) {

  }
  @media (max-width: 1200px) {

  }
  @media (max-width: 991px) {
    .faq__body {
      width: 100%;
    }

    .footer__up {
      flex-direction: column;
    }

    .footer__down {
      flex-direction: column;
      gap: 20px;
      align-items: flex-start;
    }
  }
  @media (max-width: 768px) {

  }
  @media (max-width: 500px) {

  }
  @media (max-width: 414px) {

  }
  @media (max-width: 390px) {

  }
  @media (max-width: 375px) {
    .footer__app {
      flex-direction: column;
    }
  }
  @media (max-width: 360px) {

  }
  @media (max-width: 320px) {

  }
  @media (min-width: 991px) {
     .metrika-analytics {
      position: absolute;
      bottom: 26px;
      right: 0;
     }
  }
</style>